export const itemsPerPageForAllItems  = 1000